import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    darkmodeKey: 0,
  },
  getters: {
  },
  mutations: {
    darkmodeRerender(state) {
      state.darkmodeKey += 1;
    },
  },
  actions: {
  },
  modules: {
  },
});
